export default __webpack_public_path__ + "static/8-10fd90201e0caf94b01f07daed612b71.png";